/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { cancelStationPrices } from '../fn/price/cancel-station-prices';
import { CancelStationPrices$Params } from '../fn/price/cancel-station-prices';
import { createStationsPrices } from '../fn/price/create-stations-prices';
import { CreateStationsPrices$Params } from '../fn/price/create-stations-prices';
import { CurrentStationsPricePagedList } from '../models/current-stations-price-paged-list';
import { exportStationsPrices } from '../fn/price/export-stations-prices';
import { ExportStationsPrices$Params } from '../fn/price/export-stations-prices';
import { getStationPrices } from '../fn/price/get-station-prices';
import { GetStationPrices$Params } from '../fn/price/get-station-prices';
import { getStationsCurrentPrices } from '../fn/price/get-stations-current-prices';
import { GetStationsCurrentPrices$Params } from '../fn/price/get-stations-current-prices';
import { publishStationPrices } from '../fn/price/publish-station-prices';
import { PublishStationPrices$Params } from '../fn/price/publish-station-prices';
import { retryStationPrices } from '../fn/price/retry-station-prices';
import { RetryStationPrices$Params } from '../fn/price/retry-station-prices';
import { searchStationsPrices$Any } from '../fn/price/search-stations-prices-any';
import { SearchStationsPrices$Any$Params } from '../fn/price/search-stations-prices-any';
import { searchStationsPrices$Json } from '../fn/price/search-stations-prices-json';
import { SearchStationsPrices$Json$Params } from '../fn/price/search-stations-prices-json';
import { StationPrices } from '../models/station-prices';
import { StationsPricePagedList } from '../models/stations-price-paged-list';


/**
 * All about the station's energy's prices
 */
@Injectable({ providedIn: 'root' })
export class PriceService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createStationsPrices()` */
  static readonly CreateStationsPricesPath = '/custom/stations/batch-update-price';

  /**
   * Allow to create further station's prices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStationsPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStationsPrices$Response(params: CreateStationsPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createStationsPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Allow to create further station's prices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStationsPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStationsPrices(params: CreateStationsPrices$Params, context?: HttpContext): Observable<void> {
    return this.createStationsPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchStationsPrices()` */
  static readonly SearchStationsPricesPath = '/custom/stations/request-update-price/search';

  /**
   * Search request of station's prices, sortable and filterable by all fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsPrices$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsPrices$Json$Response(params?: SearchStationsPrices$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StationsPricePagedList>> {
    return searchStationsPrices$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search request of station's prices, sortable and filterable by all fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsPrices$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsPrices$Json(params?: SearchStationsPrices$Json$Params, context?: HttpContext): Observable<StationsPricePagedList> {
    return this.searchStationsPrices$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationsPricePagedList>): StationsPricePagedList => r.body)
    );
  }

  /**
   * Search request of station's prices, sortable and filterable by all fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsPrices$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationsPrices$Any$Response(params?: SearchStationsPrices$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StationsPricePagedList>> {
    return searchStationsPrices$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search request of station's prices, sortable and filterable by all fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsPrices$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationsPrices$Any(params?: SearchStationsPrices$Any$Params, context?: HttpContext): Observable<StationsPricePagedList> {
    return this.searchStationsPrices$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationsPricePagedList>): StationsPricePagedList => r.body)
    );
  }

  /** Path part for operation `exportStationsPrices()` */
  static readonly ExportStationsPricesPath = '/custom/stations/request-update-price/export';

  /**
   * Export the requests station's prices as an XLSX File.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationsPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationsPrices$Response(params?: ExportStationsPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationsPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the requests station's prices as an XLSX File.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationsPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationsPrices(params?: ExportStationsPrices$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationsPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getStationPrices()` */
  static readonly GetStationPricesPath = '/custom/stations/request-update-price/{uid}';

  /**
   * Get a simple station's prices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationPrices$Response(params: GetStationPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPrices>> {
    return getStationPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple station's prices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationPrices(params: GetStationPrices$Params, context?: HttpContext): Observable<StationPrices> {
    return this.getStationPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPrices>): StationPrices => r.body)
    );
  }

  /** Path part for operation `cancelStationPrices()` */
  static readonly CancelStationPricesPath = '/custom/stations/request-update-price/{uid}/cancel';

  /**
   * Cancel a simple station's prices, in CREATION && ERROR state, we can ask for cancel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelStationPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelStationPrices$Response(params: CancelStationPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPrices>> {
    return cancelStationPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancel a simple station's prices, in CREATION && ERROR state, we can ask for cancel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelStationPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelStationPrices(params: CancelStationPrices$Params, context?: HttpContext): Observable<StationPrices> {
    return this.cancelStationPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPrices>): StationPrices => r.body)
    );
  }

  /** Path part for operation `retryStationPrices()` */
  static readonly RetryStationPricesPath = '/custom/stations/request-update-price/{uid}/retry';

  /**
   * Retry a simple station's prices, in ERROR state, we ca ask for retry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retryStationPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryStationPrices$Response(params: RetryStationPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPrices>> {
    return retryStationPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Retry a simple station's prices, in ERROR state, we ca ask for retry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retryStationPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryStationPrices(params: RetryStationPrices$Params, context?: HttpContext): Observable<StationPrices> {
    return this.retryStationPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPrices>): StationPrices => r.body)
    );
  }

  /** Path part for operation `publishStationPrices()` */
  static readonly PublishStationPricesPath = '/custom/stations/request-update-price/{uid}/publish';

  /**
   * Force publish a simple station's prices, in FORCED_PUBLISHED state, to apply the prices without waiting the end of the process.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishStationPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishStationPrices$Response(params: PublishStationPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPrices>> {
    return publishStationPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Force publish a simple station's prices, in FORCED_PUBLISHED state, to apply the prices without waiting the end of the process.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishStationPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishStationPrices(params: PublishStationPrices$Params, context?: HttpContext): Observable<StationPrices> {
    return this.publishStationPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPrices>): StationPrices => r.body)
    );
  }

  /** Path part for operation `getStationsCurrentPrices()` */
  static readonly GetStationsCurrentPricesPath = '/custom/stations/current-prices';

  /**
   * Get stations with current prices as info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationsCurrentPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationsCurrentPrices$Response(params?: GetStationsCurrentPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentStationsPricePagedList>> {
    return getStationsCurrentPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get stations with current prices as info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationsCurrentPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationsCurrentPrices(params?: GetStationsCurrentPrices$Params, context?: HttpContext): Observable<CurrentStationsPricePagedList> {
    return this.getStationsCurrentPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentStationsPricePagedList>): CurrentStationsPricePagedList => r.body)
    );
  }

}
